module.exports = __webpack_public_path__ + "img/2026-09-21b_1.4d8ec995.jpg";